import Lovepod from "@/components/layout/parts/Lovepod.vue";

const components = [
    Lovepod
]

export default components